<template>
  <Modal
    v-model="showModal"
    width="860"
    :transfer="true"
    class="modal-box"
    :footer-hide="true"
  >
    <p slot="header">
      批量设置<span
        v-if="activeSelection.length"
        style="padding-left: 10px; color: #999999"
        >(已选{{ activeSelection.length }})</span
      >
    </p>
    <div class="iconTips">
      <Icon
        type="md-alert"
        size="16"
        color="#ff9900"
        style="padding-right: 10px"
      ></Icon
      >每次只能批量修改一项
    </div>
    <div class="modal-content">
      <div class="modal-left">
        <div class="menu-box">
          <Menu mode="vertical" :active-name="menuName" @on-select="handleMenu">
            <MenuItem
              v-for="(item, index) in menuList"
              :key="index"
              :name="item.menuName"
            >
              {{ item.name }}
            </MenuItem>
          </Menu>
        </div>
      </div>
      <div class="modal-right">
        <div v-if="menuName == 1" class="item1">
          <RadioGroup v-model="batchData.templateSts">
            <Radio label="1">启用</Radio>
            <Radio label="0">停用</Radio>
          </RadioGroup>
        </div>
        <div v-if="menuName == 2" class="item1">
          <RadioGroup v-model="batchData.isSign">
            <Radio label="1">需要手签</Radio>
            <Radio label="0">无需手签</Radio>
          </RadioGroup>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <div class="modal-430-bottom">
      <Button @click="handleCancel">取消</Button>
      <Button type="primary" @click="handleOk">确定</Button>
    </div>
  </Modal>
</template>
<script>
import { mapGetters } from 'vuex';
import platformApi from '@/request/eduCenter/platform.js'
export default {
  props: {


    activeSelection: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showModal: false,
      menuName: "1",
      batchData: {
        templateSts: '1',
        isSign: '1'

      },

    };
  },
  computed: {
    ...mapGetters(['theUserIdentity']),
    menuList() {

      return [
        {
          menuName: '1',
          name: '模板协议状态'
        }, {
          menuName: '2',
          name: '是否需要手签'
        },
      ];

    }
  },
  watch: {
    showModal: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.menuName = this.menuList[0].menuName;
          })
        }
      }
    }

  },
  created() {
    this.menuName = this.menuList[0].menuName;
  },
  methods: {
    handleShow() {
      this.showModal = true
    },
    // 切换菜单
    handleMenu(name) {
      this.menuName = name;
    },
    // 批量设置点击取消
    handleCancel() {
      Object.keys(this.batchData).forEach((item) => {
        this.batchData[item] = '1';
      });
      // this.batchData.templateSts = '1';
      this.showModal = false
    },
    async batchUpdateAgreementTemplate(info) {
      let agreementIdList = this.activeSelection.map(item => { return item.agreementId })
      let res = await platformApi.batchUpdateAgreementTemplate({
        agreementIdList,
        ...info,
      })
      if (res.status == 200) {
        this.$Message.success('修改成功');
        this.handleCancel()
        this.$emit('on-finish')
      }
    },
    // 批量设置点击确定
    handleOk() {
      let params;
      switch (this.menuName) {
        case '1':
          this.batchUpdateAgreementTemplate({
            templateSts: this.batchData.templateSts,
            isSign: ''
          })
          break;
        case '2':
          this.batchUpdateAgreementTemplate({
            isSign: this.batchData.isSign,
            templateSts: ''
          })
          break;


      }

    },

  }
};
</script>
<style lang="scss" scoped>
.modal-box {
  .iconTips {
    display: flex;
    align-items: center;
    padding-left: 20px;
    margin: 0 0 10px 10px;
    width: 600px;
    height: 30px;
    background-color: #fadfb8;
    border: solid 1px #ff9900;
  }
  .modal-content {
    display: flex;
    justify-content: space-around;
    .modal-left {
      float: left;
    }
    .modal-right {
      float: right;
      width: 500px;
      span {
        color: rgb(160, 161, 161);
        font-size: 10px;
      }
      .item1 {
        div {
          margin: 11px 0;
        }
      }
      .item3 {
        .labelName {
          margin: 3px 0;
        }
        .batchItem {
          margin: 10px 0;
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
        }
      }
      .item2 {
        div {
          margin: 4px 0;
        }
      }
      .item4 {
        margin: 10px 0;
        .list-item {
          display: flex;
          align-items: flex-start;
        }
      }
    }
  }
}
</style>
